var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-checkbox-button-group" }, [
    _c("div", { staticClass: "boss-checkbox-button-group-title" }, [
      _vm._v("\n    表示対象者\n  "),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("label", { staticClass: "boss-checkbox-button" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selected,
              expression: "selected",
            },
          ],
          staticClass: "boss-checkbox-button-input",
          attrs: { type: "checkbox", "data-test": "entryStatusIds" },
          domProps: {
            value: _vm.entryStatusIds,
            checked: Array.isArray(_vm.selected)
              ? _vm._i(_vm.selected, _vm.entryStatusIds) > -1
              : _vm.selected,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.selected,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = _vm.entryStatusIds,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.selected = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.selected = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.selected = $$c
              }
            },
          },
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "boss-checkbox-button-content",
            attrs: { "data-test": "entryStatusNames" },
          },
          [_vm._v("エントリー中")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "label",
        {
          staticClass: "boss-checkbox-button",
          attrs: { id: "display-target-" + _vm.finishStatusId },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selected,
                expression: "selected",
              },
            ],
            staticClass: "boss-checkbox-button-input",
            attrs: { type: "checkbox", "data-test": "finishStatusId" },
            domProps: {
              value: _vm.finishStatusId,
              checked: Array.isArray(_vm.selected)
                ? _vm._i(_vm.selected, _vm.finishStatusId) > -1
                : _vm.selected,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.selected,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = _vm.finishStatusId,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.selected = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.selected = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.selected = $$c
                }
              },
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "boss-checkbox-button-content",
              attrs: { "data-test": "finishStatusName" },
            },
            [_vm._v("終了")]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }